// extracted by mini-css-extract-plugin
export default {"status":"ActiveProblemAndConditionSection_status__il0C7","stage":"ActiveProblemAndConditionSection_stage__hfRRd"};